<app-reports
  title="User Activities Audit Reports"
  [filtersForm]="filtersForm"
  [forceReportDetailsDisplay]="true"
  [validateForm]="validateForm"
  [reportsUrl]="reportsUrl"
  [reportsCountUrl]="reportsCountUrl">

  <ng-template appNewReportOptionsTemplate let-filtersForm="filtersForm">
    <ng-container [formGroup]="filtersForm">

      <app-report-date-range-option label="Created Date" formControlName="createdDate" />
      <app-report-user-activity-option label="Filter by Activity" formControlName="activity" />
      <app-report-users-option label="Users" formControlName="userIds" />
      <app-report-user-type-option label="Filter By User Types" formControlName="userType" />

    </ng-container>
  </ng-template>

  <ng-template appReportDetailsTemplate let-report="report">

    <app-report-applied-date-range-option
      [options]="report.filters"
      name="createdDate"
      label="User Activity Date" />

    <app-report-applied-user-activity-option
      [options]="report.filters"
      [optionAssociations]="report.filterAssociations"
      name="activity"
      label="User Activities" />

    <app-report-applied-users-option
      [options]="report.filters"
      [optionAssociations]="report.filterAssociations"
      name="userIds"
      label="Users" />

    <app-report-applied-user-type-option
      [options]="report.filters"
      [optionAssociations]="report.filterAssociations"
      name="userType"
      label="User Types" />


  </ng-template>

</app-reports>
